/* @ngInject */

export default ($compile) => {
  return {
    restrict: 'E',
    scope: {
      title: '='
    },
    link: function (scope, element) {
      scope.firstPart = 'N/A';
      scope.secondPart = 'N/A';
      if (scope.title) {
        var splitTitle = scope.title.split(' - ');
        scope.firstPart = splitTitle[0] + ' - ' + splitTitle[1] + ':';
        scope.secondPart = splitTitle[2];
      }
      var template = $compile(
        '<div layout="column" flex><small>{{firstPart}}</small><em>{{secondPart}}</em></div>'
      )(scope);
      element.replaceWith(template);
    }
  };
};
